import { render, staticRenderFns } from "./NexoTransactionListTable.vue?vue&type=template&id=1c988d2d&"
import script from "./NexoTransactionListTable.vue?vue&type=script&lang=js&"
export * from "./NexoTransactionListTable.vue?vue&type=script&lang=js&"
import style0 from "./NexoTransactionListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports